<template>
  <div class="side-wrap">
    <!-- {{       badgeStatistics }} -->
      <el-form ref="form" :model="form" label-width="0" size="mini">
        <div class="side-head">
            <el-button type="primary" size="mini" class="btn-search" @click="onSearch">查询</el-button>
            <el-button type="primary" size="mini" class="btn-reset" @click="onReset" plain>重置</el-button>
            <div class="icon-side-collapse"  @click="hideCollapse"></div>
        </div>
        <div class="menu-conent-top">
          <el-form-item> 
            <!-- 用户信息类型 -->
            <el-input placeholder="请输入内容" v-model="form.userInfoKeywords" >
              <el-select v-model="form.userInfoType" slot="prepend" placeholder="请选择" class="mini-select">
                <el-option v-for="item in dictionaries.ol_user_info_type" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item> 
            <!-- 单号类型 -->
            <el-input placeholder="请输入内容" v-model="form.codeKeywords" >
              <el-select v-model="form.codeType" slot="prepend" placeholder="请选择">
                <el-option v-for="item in dictionaries.ol_code_type" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item> 
            <!-- 地址类型 -->
            <el-input placeholder="请输入内容" v-model="form.postAddressKeywords">
              <el-select v-model="form.postAddressType" slot="prepend" placeholder="请选择">
                <el-option v-for="item in dictionaries.ol_post_addr_type" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item> 
            <!-- <el-input placeholder="请输入内容" v-model="form.orgCode" class="input-with-select">
              <template slot="prepend"><span class="placeholder-text">所属部门</span></template>
            </el-input> -->
            <div class="input-with-select">
              <span class="prepend-text">所属部门</span>
              <el-cascader
                  class="select"
                  :class="{'select-one':orgCodeArry.length==1,'select-two':orgCodeArry.length>1,'select-ten':orgCodeArry.length>10}"
                  v-model="orgCodeArry"
                  :options="orgCodeList"
                  :props="{ label: 'orgName', value: 'orgCode',  multiple: true, checkStrictly: true }"
                  placeholder="请选择部门"
                  @change="onChangeOrgCode"
                  :show-all-levels=false
                  collapse-tags>
                </el-cascader>
              </div>
          </el-form-item>
        </div>
        <div class="menu-conent">
          
          <div class="item-menu" :class="{ 'active': chooseMenu == 'order' }">
            <div class="menu-name" @click="toggleMenu('order')">订单状态<el-badge :hidden="!orderStatistics.total>0" :value="orderStatistics.total" class="badge" /><i class="el-icon-arrow-right icon"></i></div>
            <el-checkbox-group v-model="form.orderStatuses" class="group-con" size="mini">
              <el-checkbox  v-for="item in dictionaries.ol_order_status" :key="item.dictId" :label="item.dictId" :value="item.dictId"  >
                {{ item.dictName }}
                <el-badge :hidden="!orderStatistics[item.dictId]>0" :value="orderStatistics[item.dictId]" class="badge"/>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="item-menu" :class="{ 'active': chooseMenu == 'abnormal' }">
            <div class="menu-name" @click="toggleMenu('abnormal')">异常订单<el-badge :hidden="!exceptionStatistics.total>0" :value="exceptionStatistics.total" class="badge" /><i class="el-icon-arrow-right icon"></i></div>
            <el-checkbox-group v-model="form.orderExcs" class="group-con">
              <el-checkbox  v-for="item in dictionaries.ol_exc_order" :key="item.dictId" :label="item.dictId" :value="item.dictId"  >
                {{ item.dictName }}
                <el-badge :hidden="!exceptionStatistics[item.dictId]>0" :value="exceptionStatistics[item.dictId]" class="badge"/>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="item-menu" :class="{ 'active': chooseMenu == 'orderInfo' }">
            <div class="menu-name" @click="toggleMenu('orderInfo')">订单信息<i class="el-icon-arrow-right icon"></i></div>
            <div class="group-con group-con-form">
              <div class="item-form">
                <div class="lable">商品名称</div>
                <el-input v-model="form.orderInfos.goodsName" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">商品五域编号</div>
                <el-input v-model="form.orderInfos.wyGoodsCode" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">规格名称</div>
                <el-input v-model="form.orderInfos.goodsSkuName" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">规格编码</div>
                <el-input v-model="form.orderInfos.skuCode" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">订单类型</div>
                <el-select v-model="form.orderInfos.orderGenerateType" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option v-for="item in dictionaries.oms_order_generate_type" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">订单来源</div>
                <el-select v-model="form.orderInfos.orderOrigin" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option v-for="item in dictionaries.oms_all_order_origin" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">第三方平台</div>
                <el-select v-model="form.orderInfos.thirdParty" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有" :value="1"></el-option>
                  <el-option label="无" :value="0"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">下单时间</div>
                <el-date-picker
                    v-model="orderCreatedTime"
                    @change="onChangeTime('orderCreatedTime')"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    range-separator="至"
                    :default-time="['00:00:00', '23:59:59']"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="mini" class="data-picker" clearable>
                  </el-date-picker>
              </div>
              <div class="item-form">
                <div class="lable">付款时间</div>
                <el-date-picker
                    v-model="orderPayTime"
                    @change="onChangeTime('orderPayTime')"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    range-separator="至"
                    :default-time="['00:00:00', '23:59:59']"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="mini" class="data-picker" clearable>
                  </el-date-picker>
              </div>
              <div class="item-form">
                <div class="lable">支付方式</div>
                <el-select v-model="form.orderInfos.payType" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option v-for="item in dictionaries.oms_order_pay_type" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">支付流水号</div>
                 <el-input v-model="form.orderInfos.paymentTransactionId" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">内购价</div>
                <el-select v-model="form.orderInfos.purchaseFlag" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="否" :value="0"></el-option>
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">是否到付</div>
                <el-select v-model="form.orderInfos.codFlag" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="否" :value="0"></el-option>
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">税号</div>
                <el-input v-model="form.orderInfos.taxpayerNumber" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">配送方式</div>
                <el-select v-model="form.orderInfos.deliveryType" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="邮寄" :value="1"></el-option>
                  <el-option label="自提" :value="2"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="item-menu" :class="{ 'active': chooseMenu == 'remark' }">
            <div class="menu-name" @click="toggleMenu('remark')">留言备注<i class="el-icon-arrow-right icon"></i></div>
            <div class="group-con group-con-form">
              <div class="item-form">
                <div class="lable">买家留言</div>
                <el-select v-model="form.remarks.hasBuyerMessage" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有留言" :value="1"></el-option>
                  <el-option label="无留言" :value="2"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">商家备注</div>
                <el-select v-model="form.remarks.hasMerchantRemark" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有备注" :value="1"></el-option>
                  <el-option label="无备注" :value="2"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">客服备注</div>
                <el-select v-model="form.remarks.hasServiceRemark" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有备注" :value="1"></el-option>
                  <el-option label="无备注" :value="2"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">客服订单审核备注</div>
                <el-select v-model="form.remarks.hasAuditRemark" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有备注" :value="1"></el-option>
                  <el-option label="无备注" :value="2"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">申诉备注</div>
                <el-select v-model="form.remarks.hasAppealRemark" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有备注" :value="1"></el-option>
                  <el-option label="无备注" :value="2"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">提成审批备注</div>
                <el-select v-model="form.remarks.hasBonusAuditRemark" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有备注" :value="1"></el-option>
                  <el-option label="无备注" :value="2"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">修改备注</div>
                <el-select v-model="form.remarks.hasCommissionRemark" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有修改" :value="1"></el-option>
                  <el-option label="无修改" :value="2"></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">售后件备注</div>
                <el-select v-model="form.remarks.hasAfterSalesRemark" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option label="有备注" :value="1"></el-option>
                  <el-option label="无备注" :value="2"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="item-menu" :class="{ 'active': chooseMenu == 'kefu' }">
            <div class="menu-name" @click="toggleMenu('kefu')">客服信息<i class="el-icon-arrow-right icon"></i></div>
            <div class="group-con group-con-form">
              <div class="item-form">
                <div class="lable">客服部门</div>
                <el-cascader
                  size="mini"
                  v-model="sysUserOrgArry"
                  :options="orgCodeList"
                  :props="{ label: 'orgName', value: 'orgCode', children: 'children', multiple: false, checkStrictly: true }"
                  placeholder="请输入内容"
                  @change="onChangeOrgCode($event,'kefu')"
                  :show-all-levels=false
                  collapse-tags clearable>
                </el-cascader>
              </div>
              <div class="item-form">
                <div class="lable">跟进客服</div>
                <el-input v-model="form.serviceInfos.followUpServiceName" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">客服下单时间</div>
                <el-date-picker
                    v-model="serviceOrderTime"
                    @change="onChangeTime('serviceOrderTime')"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    range-separator="至"
                    :default-time="['00:00:00', '23:59:59']"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="mini" class="data-picker" clearable>
                  </el-date-picker>
              </div>
              <div class="item-form">
                <div class="lable">提成类型</div>
                <el-select v-model="form.serviceInfos.bonusType" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option v-for="item in dictionaries.oms_bonus_type" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">提成审批状态</div>
                <el-select v-model="form.serviceInfos.bonusReviewStatus" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option v-for="item in dictionaries.oms_bonus_review_status" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">提成审核人</div>
                <el-input v-model="form.serviceInfos.bonusAuditorName" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">修改人</div>
                <el-input v-model="form.serviceInfos.bonusModifierName" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
            </div>
          </div>
          <div class="item-menu" :class="{ 'active': chooseMenu == 'logistics' }">
            <div class="menu-name" @click="toggleMenu('logistics')">物流信息<i class="el-icon-arrow-right icon"></i></div>
             <div class="group-con group-con-form">
              <div class="item-form">
                <div class="lable">最晚发货时间</div>
                <el-date-picker
                    v-model="latestDeliveryTime"
                    @change="onChangeTime('latestDeliveryTime')"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    range-separator="至"
                    :default-time="['00:00:00', '23:59:59']"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="mini" class="data-picker" clearable>
                  </el-date-picker>
              </div>
              <div class="item-form">
                <div class="lable">发货时间</div>
                <el-date-picker
                    v-model="deliveryTime"
                    @change="onChangeTime('deliveryTime')"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    range-separator="至"
                    :default-time="['00:00:00', '23:59:59']"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="mini" class="data-picker" clearable>
                  </el-date-picker>
              </div>
              <div class="item-form">
                <div class="lable">发货仓</div>
                <el-select v-model="form.logisticsInfos.warehouseId" placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option v-for="item in warehouseList" :key="item.id" :label="item.warehouseName" :value="item.id" ></el-option>
                </el-select>  
              </div>
              <div class="item-form">
                <div class="lable">快递公司</div>
                <el-select v-model="form.logisticsInfos.logisticsCompanyCode" filterable  placeholder="请选择" size="mini" class="select-mini" clearable>
                  <el-option v-for="(item,index) in dictionaries.courier_company" :key="item.dictId +'-'+ index" :label="item.dictName" :value="item.dictId" ></el-option>
                </el-select>
              </div>
              <div class="item-form">
                <div class="lable">物流单号</div>
                <el-input v-model="form.logisticsInfos.logisticsNumber" placeholder="请输入内容" size="mini" clearable></el-input>
              </div>
              <div class="item-form">
                <div class="lable">指定快递</div>
                <el-select v-model="form.logisticsInfos.specifiedLogisticsId" filterable placeholder="请选择" size="mini" class="select-mini" clearable>
                 <el-option v-for="item in dictionaries.oms_logistics_company" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="item-menu" :class="{ 'active': chooseMenu == 'afterSales' }">
            <div class="menu-name" @click="toggleMenu('afterSales')">售后信息<i class="el-icon-arrow-right icon"></i></div>
             <div class="group-con group-con-form">
                <div class="item-form">
                  <div class="lable">是否存在退货</div>
                  <el-select v-model="form.afterSalesInfos.hasAfterSales" placeholder="请选择" size="mini" class="select-mini" clearable>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </div>
                <div class="item-form">
                  <div class="lable">发起退货时间</div>
                <el-date-picker
                    v-model="afterSalesApplyTime"
                    @change="onChangeTime('afterSalesApplyTime')"
                    type="datetimerange"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    range-separator="至"
                    :default-time="['00:00:00', '23:59:59']"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="mini" class="data-picker" clearable>
                  </el-date-picker>
                </div>
                <div class="item-form">
                  <div class="lable">售后类型</div>
                  <el-select v-model="form.afterSalesInfos.afterSalesStatus" placeholder="请选择" size="mini" class="select-mini" clearable>
                    <el-option v-for="item in dictionaries.oms_after_sales_type" :key="item.dictId" :label="item.dictName" :value="item.dictId" ></el-option>
                  </el-select>
                </div>
                <div class="item-form">
                  <div class="lable">售后件登记</div>
                  <el-select v-model="form.afterSalesInfos.itemCondition" placeholder="请选择" size="mini" class="select-mini" clearable>
                    <el-option label="完好" :value="1"></el-option>
                    <el-option label="破损" :value="2"></el-option>
                    <el-option label="漏件" :value="3"></el-option>
                  </el-select>
                </div>
                <div class="item-form">
                  <div class="lable">是否理赔</div>
                  <el-select v-model="form.afterSalesInfos.isClaim" placeholder="请选择" size="mini" class="select-mini" clearable>
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="2"></el-option>
                  </el-select>
                </div>
                <div class="item-form">
                  <div class="lable">售后阶段</div>
                  <!-- 0-无售后，1-审核中，2-待寄回，3-退货中，4-待换货，5-换货中，6-售后关闭，7-商家拒绝售后，8-售后完成 -->
                  <el-select v-model="form.afterSalesInfos.afterSalesSubsetStatus" placeholder="请选择" size="mini" class="select-mini" clearable>
                    <el-option label="无售后" :value="0"></el-option>
                    <el-option label="审核中" :value="1"></el-option>
                    <el-option label="待寄回" :value="2"></el-option>
                    <el-option label="退货中" :value="3"></el-option>
                    <el-option label="待换货" :value="4"></el-option>
                    <el-option label="换货中" :value="5"></el-option>
                    <el-option label="售后关闭" :value="6"></el-option>
                    <el-option label="商家拒绝售后" :value="7"></el-option>
                    <el-option label="售后完成" :value="8"></el-option>
                  </el-select>
                </div>
             </div>
          </div>
          <div class="item-menu" :class="{ 'active': chooseMenu == 'tag' }">
            <div class="menu-name" @click="toggleMenu('tag')">标签<i class="el-icon-arrow-right icon"></i></div>
             <div class="group-con group-con-form">
                <div class="item-form">
                  <div class="lable">包含标签</div>
                  <div class="select-box" @click="onSelectTag('includeTag')">
                    <template v-if="includeTag.tagIds && includeTag.tagIds.length > 0">
                      <template v-if="includeTag.radio">
                        <span :class="'tag-no tag-'+includeTag.radio"></span>
                      </template>
                      <template v-if="includeTag.check && includeTag.check.length > 0">
                        <span v-for="(tag, index) in includeTag.checkList" :key="index" :class="`tag-text tag-${tag.tagType==3?'red':'black'}`">{{ tag.tagName }}</span>
                      </template>
                      <i @click.stop="clearTag('includeTag')" class="el-icon-circle-close select-close"></i>
                    </template>
                    <template v-else>
                      <div class="text">请选择</div>
                      <i class="el-icon-arrow-down select-arrow"></i>
                    </template>
                  </div>
                  <!-- <el-select v-model="form.includeTagIds" placeholder="请选择" size="mini" class="select-mini"></el-select> -->
                </div>
                <div class="item-form">
                  <div class="lable">排除标签</div>
                  <div class="select-box" @click="onSelectTag('excludeTag')">
                    <template v-if="excludeTag.tagIds && excludeTag.tagIds.length > 0">
                      <template v-if="excludeTag.radio">
                        <span :class="'tag-no tag-'+excludeTag.radio"></span>
                      </template>
                      <template v-if="excludeTag.check && excludeTag.check.length > 0">
                        <span v-for="(tag, index) in excludeTag.checkList" :key="index" :class="`tag-text tag-${tag.tagType==3?'red':'black'}`">{{ tag.tagName }}</span>
                      </template>
                      <i @click.stop="clearTag('excludeTag')" class="el-icon-circle-close select-close"></i>
                    </template>
                    <template v-else>
                      <div class="text">请选择</div>
                      <i class="el-icon-arrow-down select-arrow"></i>
                    </template>
                  </div>
                  <!-- <el-select v-model="form.excludeTagIds" placeholder="请选择" size="mini" class="select-mini"></el-select> -->
                </div>
             </div>
          </div>
          <!-- <div class="item-menu" :class="{ 'active': chooseMenu == 'online' }">
            <div class="menu-name" @click="toggleMenu('online')">同步线上失败<el-badge :value="4" class="badge"/><i class="el-icon-arrow-right icon"></i></div>
            <el-checkbox-group v-model="form.onlineList" class="group-con">
              <el-checkbox :label="1">下载同步失败<el-badge :value="1" class="badge"/></el-checkbox>
              <el-checkbox :label="2">上传同步失败<el-badge :value="3" class="badge"/></el-checkbox>
            </el-checkbox-group>
          </div> -->
        </div>
      </el-form>
    </div>
</template>
<script>
const defaultForm = { 
  userInfoType:'1',
  userInfoKeywords:'',
  codeType:'1',
  codeKeywords:'',
  postAddressType:'1',
  postAddressKeywords:'',
  orgCode:'',
  orderStatuses:['1','2','3','4','5','6','7','8','9','10'],
  // orderExcs:['1','2','3','4','5','6','7','8','9','10','11','12','13','99'],
  // orderStatuses:[],
  orderExcs:[],
  orderInfos:{
    goodsName:'',
    wyGoodsCode:'',
    goodsSkuName:'',
    skuCode:'',
    orderGenerateType:'',
    orderOrigin:'',
    thirdParty:'',
    createdTimeStart:'',
    createdTimeEnd:'',
    payTimeStart:'',
    payTimeEnd:'',
    payType:'',
    paymentTransactionId:'',
    purchaseFlag:'',
    codFlag:'',
    taxpayerNumber:''
  },
  remarks:{
    hasBuyerMessage:'',
    hasMerchantRemark:'',
    hasServiceRemark:'',
    hasAuditRemark:'',
    hasAppealRemark:'',
    hasBonusAuditRemark:'',
    hasCommissionRemark:'',
    hasAfterSalesRemark:'',
  },
  serviceInfos:{
    sysUserOrg:'',
    serviceOrderTimeStart:'',
    serviceOrderTimeEnd:'',
    bonusType:'',
    bonusReviewStatus:'',
    bonusAuditorName:'',
    bonusModifierName:'',
  },
  logisticsInfos:{ 
    latestDeliveryTimeStart:'',
    latestDeliveryTimeEnd:'',
    deliveryTimeStart:'',
    deliveryTimeEnd:'',
    warehouseId:'',
    logisticsCompanyCode:'',
    specifiedLogisticsId:'',
    logisticsNumber:'',
  },
  afterSalesInfos:{
    hasAfterSales:'',
    afterSalesApplyTimeStart:'',
    afterSalesApplyTimeEnd:'',
    afterSalesStatus:'',
    itemCondition:'',
    isClaim:'',
    afterSalesSubsetStatus:'',

  },
  onlineList:[],
  tagInfos:{}
}
  export default {
    name:'saleOrderSide',
    computed: {
      radioList() {
        return this.$parent.flagTags
      },
      checkList() {
        return this.$parent.textTags
      }
    },
    data () {
      return {
        form:JSON.parse(JSON.stringify(defaultForm)),
        chooseMenu:'order',// order abnormal orderInfo remark kefu logistics afterSales tag
        orgCodeList:[],
        orgCodeArry:[],
        orderCreatedTime:[],
        orderPayTime:[],
        sysUserOrgArry:[],
        serviceOrderTime:[],
        latestDeliveryTime:[],
        deliveryTime:[],
        warehouseList:[],
        afterSalesApplyTime:[],
        includeTag:{
          tagIds:[],
          radio:'',
          check:[]
        },
        excludeTag:{
          tagIds:[],
          radio:'',
          check:[]
        },
        orderStatistics:{}, // 订单状态统计数据
        exceptionStatistics:{}, // 异常订单统计数据
        exceptionTotal:0,
        
      dictionaries: { // 字典数据
        ol_user_info_type: [], // 销售订单列表用户信息类型
        ol_code_type: [], // 单号类型
        ol_post_addr_type: [], // 地址类型
        ol_order_status:[], // 9个订单状态
        ol_exc_order:[], // 异常订单
        oms_order_generate_type: [],// 订单类型
        oms_all_order_origin: [],//订单来源
        oms_order_pay_type:[], // 支付方式
        oms_bonus_type:[], // 提成类型
        oms_bonus_review_status:[], // 提成审核状态
        oms_logistics_company:[], // 指定快递
        courier_company:[], // 快递公司
        oms_after_sales_type:[], //售后类型
        // oms_audit_status:[], // 审核状态 
      }
      }
    },
    created(){
      this.$bus.$on('hasSelectTag', data=> this.setTag(data));
      for (const type in this.dictionaries) { this.getDictionaries(type) }
      this.getOrgTreeList() // 公司部门
    },
    beforeDestroy() {
      this.$bus.$off('hasSelectTag');
    },
    methods: {
      // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) { return }
        const params = { groupId: type }
        this.$api.dictionaries(params).then((res) => {
          this.dictionaries[type] = res.data
        }).catch((err) => {
          console.log(err)
        })
      },
      // 公司部门
        getOrgTreeList(params) {
            // orgProcessOrgList
            const paramsVersion = { 'request': { 'orgName': '', 'orgType': '' }, 'version': '' }
            this.$api.orgTreeList(paramsVersion).then((res) => {
                this.orgCodeList = res.data

                // id 为 1 的超级管理员不做默认
                // const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                // if (userInfo && userInfo.id !== 1) {
                //     if (res.data[0].children) {
                //         this.orgCodeArry = [...userInfo.orgCodes]
                //     } else {
                //         this.orgCodeArry.push(userInfo.orgCode)
                //     }
                //     let orgCode =  String(this.orgCodeArry) 
                //     if (orgCode) {
                //       this.form.orgCode = orgCode
                //       this.onSearch()
                //     }
                    
                // }
            }).catch((err) => {
                console.log(err)
            })
        },
        onChangeOrgCode(e,type){
          console.log('org:',e)
          let lastCode
           if (type=='kefu') {
            lastCode = String(e[e.length-1])
            this.form.serviceInfos.sysUserOrg = lastCode //客服部门
          }else{
            lastCode =  e.map(item => item[item.length - 1]);
            this.form.orgCode = String(lastCode) // 所属部门
          }
          
        },
        onChangeTime(type){
          console.log(type)
          if (type === 'orderCreatedTime') {
            this.form.orderInfos.createdTimeStart = this.orderCreatedTime[0]
            this.form.orderInfos.createdTimeEnd = this.orderCreatedTime[1]
          }else if (type === 'orderPayTime') {
            this.form.orderInfos.payTimeStart = this.orderPayTime[0]
            this.form.orderInfos.payTimeEnd = this.orderPayTime[1]
          }else if (type === 'serviceOrderTime') {
            this.form.serviceInfos.serviceOrderTimeStart = this.serviceOrderTime[0]
            this.form.serviceInfos.serviceOrderTimeEnd = this.serviceOrderTime[1]
          }else if (type === 'latestDeliveryTime') {
            this.form.logisticsInfos.latestDeliveryTimeStart = this.latestDeliveryTime[0]
            this.form.logisticsInfos.latestDeliveryTimeEnd = this.latestDeliveryTime[1]
          }else if (type === 'deliveryTime') {
            this.form.logisticsInfos.deliveryTimeStart = this.deliveryTime[0]
            this.form.logisticsInfos.deliveryTimeEnd = this.deliveryTime[1]
          }else if (type === 'afterSalesApplyTime') {
            this.form.afterSalesInfos.afterSalesApplyTimeStart = this.afterSalesApplyTime[0]
            this.form.afterSalesInfos.afterSalesApplyTimeEnd = this.afterSalesApplyTime[1]
          }
        },
      hideCollapse() {
        this.$parent.isCollapse = false
      },
      toggleMenu(text) {
        this.chooseMenu = this.chooseMenu==text?'':text
      },
      onSearch(){
        this.$emit('fetchData','search')
      },
      onReset(){
        this.form = JSON.parse(JSON.stringify(defaultForm)),
        this.orgCodeArry = []
        this.orderCreatedTime =[],
        this.orderPayTime = [],
        this.sysUserOrgArry = []
        this.afterSalesApplyTime=[],
        this.serviceOrderTime = []
        this.latestDeliveryTime = []
        this.deliveryTime = []
        this.includeTag = {}
        this.excludeTag = {}
        this.chooseMenu = 'order'
        this.$emit('fetchData','search')
      },

      onSelectTag(type){
        let data = {}
        if (type =='includeTag') {
          data =  {
            type,
            radio:this.includeTag.radio,
            check:this.includeTag.check||[],
          }
        }else if (type =='excludeTag') {
          data =  {
            type,
            radio:this.excludeTag.radio,
            check:this.excludeTag.check||[],
          }
        }
        this.$bus.$emit('onSelectTag', data);
      },
      setTag(data){
        console.log('setTag>>',data)
        if (data.type =='includeTag') {
          this.includeTag = data
          this.form.tagInfos.includeTagIds = data.tagIds
          this.includeTag.checkList = this.checkList.filter(e=>data.check.includes(e.tagId))
        }else if (data.type =='excludeTag') {
          this.excludeTag = data
          this.form.tagInfos.excludeTagIds = data.tagIds
          this.excludeTag.checkList = this.checkList.filter(e=>data.check.includes(e.tagId))
        }
        this.$emit('fetchData','search')
      },
      clearTag(type){
        if(type =='includeTag'){ 
          this.includeTag = {}
          this.form.tagInfos.includeTagIds = []
        }else if(type =='excludeTag'){ 
          this.excludeTag = {}
          this.form.tagInfos.excludeTagIds = []
        }
        this.$emit('fetchData','search')
      }
    },
  }
</script>
<style lang='scss'>
.input-with-select{
      display: flex;
      align-items: center;
      .prepend-text{
        width: 90px;
        flex-shrink: 0;
        background-color: #F5F7FA;
        border: 1px solid #DCDFE6;
        border-right: none;
        font-size: 12px;
        color: #909399;
        font-family:Arial;
        height: 24px;
        line-height: 22px;
        box-sizing: border-box;
        padding: 0 0 0 6px;
      }
      .select{
        border-radius: 0;
        line-height: 24px;
        .el-input__inner{
          border-radius: 0;
          padding: 0 8px 0 0;
          font-size: 12px;
          font-family:Arial;
          height: 24px!important;
        }
        .el-input__suffix{
          display: none;
        }
        .el-cascader__tags{
          flex-wrap: nowrap;
          cursor: pointer;
          justify-content: flex-end;
          right: 3px;
          .el-tag{
            margin: 0;
            padding: 0 1px;
            height: 18px;
            max-width: calc(100% - 3px);
            // background-color: #fff;
          }
          
          .el-tag__close{
            display: none;
          }
        }
      }
      // .select-one .el-cascader__tags{
        
      // }
      .select-two .el-cascader__tags{
        .el-tag{
          max-width: calc(100% - 25px);
          // margin-right: 2px;
        }
        .el-tag:last-child{
            // letter-spacing: -1px;
             margin-left: 2px;
             & span::first-letter{
              margin-right: -2px;
             }
          }
      }
      .select-ten .el-cascader__tags{
        .el-tag{
          max-width: calc(100% - 32px);
        }
      }
    }
</style>
<style lang='scss' scoped>

.side-wrap{
    width: 200px;
    background: #FFFFFF;
    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.08);
    border-radius: 0px 4px 4px 0px;
    
    box-sizing: border-box;
    padding: 10px 0 10px 10px;
    .side-head{
      width: 100%;
      display: inline-flex;
      margin-bottom: 10px;
      .btn-search{
        width: 90px;
        margin-right: 0;
      }
       .btn-reset{
        width: 50px;
        margin-right: 6px;
        margin-left: 6px;
      }
      .icon-side-collapse{
        display: inline-block;
          width: 28px;
          height: 24px;
          box-sizing: border-box;
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid #DCDEE1;
          cursor: pointer;
          background-image: url('~@/assets/sale/icon-side-collapse.png');
          background-size: 14px 13px;
          background-position: center center;
          background-repeat: no-repeat;
        }
    }
    .menu-conent-top{
      padding-right: 10px;
    }
    .menu-conent{
      height: calc(100vh - 282px);
      scrollbar-width: thin;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .el-form{
       .el-form-item{
          margin-right: 0;
          margin-bottom: 10px;
        }
        /deep/ {
            .el-form-item__content{
              line-height: 1;
            }
            .el-input-group__prepend{
              width: 90px;
              padding: 0 12px 0 10px;
              box-sizing: border-box;
              // font-family: PingFang SC;
              // font-weight: 400;
              .el-input__inner{
                padding: 0 10px 0 7px;
                text-align: left;
              }
            }
            .el-input__inner{
              padding: 0 8px 0 0;
              text-align: right;
              
            }
            .group-con-form{
              .el-input--mini,
              .el-cascader--mini{
                width: 180px;
              }
              .el-input__inner{
                border-radius: 2px;
                text-align: left;
                padding: 0 10px 0 8px;
                max-width: 180px;
              }
            }
            .el-checkbox{
              display: block;
              margin-bottom: 8px;
              .el-checkbox__inner::after{
                height: 6px;
                left: 3px;
              }
              .el-checkbox__inner{
                width: 12px;
                height: 12px;
                margin-top: 1px;
              }
              .el-checkbox__label{
                padding-left: 4px;
                font-size: 12px;
                line-height: 18px;
              }
            }
            .el-checkbox__input.is-checked+.el-checkbox__label{
              color: #606266;
            }
          }
    }
    
    .item-menu{
      .menu-name{
        width: 180px;
        display: inline-flex;
        line-height: 39px;
        border-top: 1px solid #F7F7F7;
        height: 40px;
        padding-left: 6px;
        box-sizing: border-box;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #333333;
        position: relative;
        cursor: pointer;
        .badge{
          margin-top: 8px;
          margin-left: 4px;
        }
        .icon{
          position: absolute;
          right: 2px;
          top: 15px;
          color: #C5C5C5;
          transition: .1s;
          font-size: 11px;
        }
      }
      .group-con{
        display: none;
        padding-left: 16px;
        padding-top: 4px;
        .badge{
          margin-top: -2px;
          margin-left: 1px;
          position: absolute;
        }
      }
      .group-con-form{
        padding-left: 0;
        padding-top: 8px;
        .item-form{
          margin-bottom: 10px;
        }
        .lable{
          font-size: 12px;
          text-indent: 4px;
          line-height: 20px;
        }
      }
      &.active{
        .icon{
          transform: rotate(90deg);
        }
        .group-con{
          display: block;
        }
      }
    }
     .placeholder-text{
      font-family: Arial;
      font-weight: 400;
      position: relative;
      left: -2px;
      top: -1px;
    }
    .select-box{
      border-radius: 2px;
      text-align: left;
      padding: 0 22px 0 1px;
      max-width: 180px;
      height: 24px;
      line-height: 22px;
      border: 1px solid #DCDFE6;
      box-sizing: border-box;
      cursor: pointer;
      font-size: 11px;
      color:#c8ccd3;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      &:hover{ 
        border-color: #C0C4CC;
      }
      .select-close{
        font-size: 11px;
        color: #C0C4CC;
        position: absolute;
        right:6px;
        top: 5px;
      }
      .select-arrow{
        font-size: 11px;
        color: #C0C4CC;
        position: absolute;
        right: 6px;
        top: 5px;
      }
      .tag-no{
        border: none;
      }
      .tag-text{
        height: 20px;
        line-height: 18px;
      }
      .text{
        padding: 0 0 0 6px;
      }
    }
  }
</style>